// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-image{width:auto;height:auto;display:block;max-width:100%;max-height:100%;filter:blur(10px);transition:filter .5s}.czt-image.is-lazy.is-loaded,.czt-image.is-notLazy{filter:blur(0)}", ""]);
// Exports
module.exports = exports;
